G.WorldMapPlayerAvatar = function(worldMap) {
  Phaser.Group.call(this, game);

  this.state = game.state.getCurrentState();

  this.visibilityState = G.WorldMapPlayerAvatar.VisibilityStates.Visible;

  this.onAnimFinished = new Phaser.Signal();

  // this.avatar = G.makeExtImage(0,0,'avatar_m','avatar_m',0,this,false,function(){
  //   this.width = this.height = 80;
  // });
  this.avatar = G.makeImage(0,-8,'avatar_m', 0, this);
  this.avatar.anchor.setTo(0.5);
  this.avatar.width = this.avatar.height = 80;
  this.pivotTween = game.add.tween(this.pivot)
    .to({x: 10}, 500, Phaser.Easing.Sinusoidal.InOut,true, 0, -1, true);
  this.add(this.avatar);
  var frame = G.makeImage(0, 0, "avatar_frame_big", [0.5, 0.52] , this);
  frame.position = this.avatar.position;

  this.position = worldMap.position;

  if (this.state.lastLevelData) {
    this.animPosToLevel(this.state.lastLevelData.lvlNr, G.saveState.getLastPassedLevelNr());
  } else {
    this.setPosToLevel(G.saveState.getLastPassedLevelNr());
  }

};

G.WorldMapPlayerAvatar.prototype = Object.create(Phaser.Group.prototype);

G.WorldMapPlayerAvatar.VisibilityStates = {
  Visible: 'visible',
  HiddenAbove: 'hiddenAbove',
  HiddenBelow: 'hiddenBelow'
};

G.WorldMapPlayerAvatar.prototype.setPosToLevel = function(lvlIndex) {
  var levelDataMgr = G.Helpers.levelDataMgr;

  lvlIndex = game.math.clamp(lvlIndex, 0, levelDataMgr.getMaxLevelIndex());

  var lvl = levelDataMgr.getLevelByIndex(lvlIndex);
  if (lvl) {
    this.avatar.x = lvl.mapX - 90;
    this.avatar.y = lvl.mapY - 10;
  }

  this.onAnimFinished.dispatch();
};

G.WorldMapPlayerAvatar.prototype.animPosToLevel = function(prevLvlIndex, lvlIndex) {
  var levelDataMgr = G.Helpers.levelDataMgr;

  prevLvlIndex = game.math.clamp(prevLvlIndex, 0, levelDataMgr.getMaxLevelIndex()); 
  lvlIndex = game.math.clamp(lvlIndex, 0, levelDataMgr.getMaxLevelIndex());

  var prevLvl = levelDataMgr.getLevelByIndex(prevLvlIndex);
  var lvl = levelDataMgr.getLevelByIndex(lvlIndex);

  if (prevLvl) {
    this.avatar.x = prevLvl.mapX - 90;
    this.avatar.y = prevLvl.mapY - 10;
  }

  if (lvl) {
    game.add.tween(this.avatar)
      .to({x: lvl.mapX-90, y: lvl.mapY-10}, 1000, Phaser.Easing.Sinusoidal.InOut, true)
      .onComplete.add(function() {
        this.onAnimFinished.dispatch();
      }, this);

  } else {
    this.onAnimFinished.dispatch();
  }
};